import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { FILL_RATE_BY_PRODUCT_LIST_CHART_DEFINITION } from './fill-rate-by-product-list-chart.definition';
import { FILL_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './fill-rate-by-product-list-chart.mock';

export const FillRateByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

FillRateByProductListChart.definition = FILL_RATE_BY_PRODUCT_LIST_CHART_DEFINITION;
FillRateByProductListChart.mockData = FILL_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA;
